import objectToXML from 'object-to-xml';

// @ts-expect-error Doesn’t come with types
/**
 * Transform an object into an XML response
 */
function createXmlResponse(c, data) {
    c.header('Content-Type', 'application/xml');
    const obj = {
        '?xml version="1.0" encoding="UTF-8"?': null,
        ...data,
    };
    return c.text(objectToXML(obj), 200, {
        'Content-Type': 'application/xml; charset=UTF-8',
    });
}

export { createXmlResponse };
